<template>
  <pt-news-detail class="pt-news-detail__page" :id="id"></pt-news-detail>
</template>

<script>
import PtNewsDetail from 'cps/information-manage/pt-news-manage/pt-news-detail/withData'
export default {
  name: 'pt-news-detail__view',
  components: {
    'pt-news-detail': PtNewsDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
